import * as Components from '../components';
Components.mountAll(Components);
